import { omit } from 'lodash/fp';
import { mapProps, compose } from 'recompose';

const omitProps = compose(mapProps, omit);

export default omitProps;
